<template>
  <div class="register_success_wrapper">
    <img src="@/assets/images/basic/register_success.png"
         width="274px"
         height="274px">
    <p class="font24">修改成功！</p>
    <div class="service_box">
      <p v-if="type">{{type}} 为您绑定的新{{title}}。</p>
      <p v-else>{{ title + action }}成功！</p>
    </div>
    <div class="service_box" v-if="source != 'jd'">
        <p class="btn_shopping">返回 <a class="yonghu" @click="toSafeCenter">账户与安全</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateSuccess',
  props: {
    title: String,
    type:String,
    action: {
      type: String,
      required: false,
      default: '绑定'
    },
    source:{
        type: String,
        default: ''
    }
  },
  methods: {
    toSafeCenter() {
      this.$router.push('/safe')
    }
  }
}
</script>

<style scoped>
    .register_success_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    }
    .font24 {
    font-size: 24px;
    }
 .yonghu{
    width: 89px;
    height: 22px;
    font-family: AlibabaPuHuiTiR;
    font-size: 14px;
    color: #FD5902;
    letter-spacing: 0;
    line-height: 22px;
 }

 .service_box {
    margin-top: 25px;
  }

 
</style>


// WEBPACK FOOTER //
// src/components/user/account/BindSuccess.vue